import { Loader2, X } from "lucide-react";

export function UserSheet({ user, matchInfo, matching, onClose, onSend }) {
  if (!user) return null;
  const score = matchInfo?.score ?? 0;
  return (
    <div
      className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm flex items-end md:items-center justify-center"
      onClick={onClose}
    >
      <div
        className="glass w-full md:max-w-md md:rounded-3xl rounded-t-3xl p-6 border-t md:border border-white/10 relative"
        onClick={(e) => e.stopPropagation()}
        data-testid="user-sheet"
      >
        <button data-testid="close-user-sheet" onClick={onClose} className="absolute top-4 right-4 text-white/50 hover:text-white"><X size={18} /></button>
        <div className="text-[10px] tracking-[0.3em] font-mono text-[#00E5FF]">// SIGNAL DETAIL</div>
        <h3 className="font-[Unbounded] text-2xl mt-2">{user.display_name}</h3>
        <p className="text-white/50 text-sm mt-1">{user.bio || "No bio."}</p>

        <div className="mt-6 flex items-center gap-6">
          <div className="relative w-24 h-24">
            <svg viewBox="0 0 100 100" className="w-full h-full -rotate-90">
              <circle cx="50" cy="50" r="42" stroke="rgba(255,255,255,0.08)" strokeWidth="6" fill="none" />
              <circle
                cx="50" cy="50" r="42"
                stroke={matchInfo ? "#00E5FF" : "rgba(255,255,255,0.1)"}
                strokeWidth="6"
                strokeLinecap="round"
                strokeDasharray={`${score * 2.64} 264`}
                fill="none"
                style={{ transition: "stroke-dasharray 0.8s ease" }}
              />
            </svg>
            <div className="absolute inset-0 flex flex-col items-center justify-center">
              {matching ? <Loader2 size={16} className="animate-spin text-[#00E5FF]" /> : (
                <>
                  <span className="font-[Unbounded] text-2xl font-bold">{matchInfo?.score ?? "--"}</span>
                  <span className="text-[9px] font-mono tracking-widest text-white/40">MATCH</span>
                </>
              )}
            </div>
          </div>
          <div className="flex-1">
            <div className="text-[10px] font-mono tracking-widest text-white/40">AI REASON</div>
            <p className="text-sm text-white/80 mt-1">{matching ? "Analyzing signals…" : matchInfo?.reason || "—"}</p>
          </div>
        </div>

        <div className="mt-6 flex flex-wrap gap-1">
          {(user.interests || []).map((t) => (
            <span key={t} className="text-[10px] font-mono px-2 py-1 rounded-full bg-white/5 border border-white/10 text-white/70">{t}</span>
          ))}
        </div>

        {matchInfo?.icebreaker && (
          <div className="mt-6 p-4 bg-[#00E5FF]/10 border border-[#00E5FF]/30 rounded-xl">
            <div className="text-[10px] tracking-widest font-mono text-[#00E5FF] mb-1">SUGGESTED OPENER</div>
            <p className="text-sm">{matchInfo.icebreaker}</p>
          </div>
        )}

        <button
          data-testid="connect-btn"
          onClick={onSend}
          className="w-full mt-6 bg-[#00E5FF] text-black font-semibold py-3 rounded-full hover:glow-primary transition-all"
        >
          Send Signal
        </button>
      </div>
    </div>
  );
}
